export default {"src":"/_next/static/media/facebook-icon.6ea4f0e8.svg","height":20,"width":11};